import { render, staticRenderFns } from "./TiposDeVeiculos.vue?vue&type=template&id=96a54218&"
import script from "./TiposDeVeiculos.vue?vue&type=script&lang=js&"
export * from "./TiposDeVeiculos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports